import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { IRectangleProps } from './RectanglePlaceholder';

type StyledRectangleProps = IRectangleProps;

export const StyledRectangle = styled.div<StyledRectangleProps>`
  margin: 0;
  background-color: ${theme.color.background.disabled};
  width: ${(props) => {
    return props.widthCss || props.size || '100%';
  }};
  height: ${(props) => {
    return props.heightCss || props.size || '100%';
  }};
  border-radius: 5px;
`;
